import { AISummarizeKind } from 'Generated/schema';

/** Kinds that use the conversational sidesheet (multi-turn) instead of legacy single-shot. */
export const CONVERSATIONAL_KINDS = new Set([AISummarizeKind.Alert, AISummarizeKind.AlertList]);

export const conversationInput = (
  alias: string,
  kind: AISummarizeKind,
  pageSize: number,
  cursor?: string,
) => ({
  input: {
    aliases: [alias],
    kinds: [kind],
    pageSize,
    ...(cursor && { cursor }),
  },
});
